import React, { useState, useEffect } from 'react';
import ErpTemplate from '../../components/ErpTemplate';
import { FaSave, FaArrowLeft, FaPlus } from 'react-icons/fa';
import api from '../../services/api';
import { useHistory } from 'react-router-dom';
import ReactSelect from '../../components/ReactSelect';
import { virgulaPonto, pontoVirgula, extract } from '../../util/util';
import { toast } from 'react-toastify';
import { Modal } from 'react-bootstrap';
import SaveButton from '../../components/SaveButton';


export default function CadastroProduto({ match }) {
    const id = match.params.id;
    const empresa = localStorage.getItem("empresa");
    const perfilRaw = localStorage.getItem("perfil") || "";
    const perfis = perfilRaw
        .toLowerCase()
        .split(',')
        .map(p => p.trim())
        .filter(Boolean);
    const isSomenteConsulta = perfis.includes('evento') || perfis.includes('gerenteevento') || perfis.includes('gerenteeventointernacional');
    const token = localStorage.getItem('token');
    const [dados, setDados] = useState([]);
    const [isSubmitting, setIsSubmitting] = useState(false);
    const [isLoading, setIsLoading] = useState(!!id);
    const [showModalNovoGrupo, setShowModalNovoGrupo] = useState(false);
    const [salvandoNovoGrupo, setSalvandoNovoGrupo] = useState(false);
    const [grupoSelectKey, setGrupoSelectKey] = useState(0);
    const [novoGrupo, setNovoGrupo] = useState({
        nome: '',
        codigo: '',
        ordem: ''
    });
    const history = useHistory();

    const buscar = () => {
        setIsLoading(true);
        if (id) {
            api({
                method: "get",
                action: '/produto/' + id,
                token: token,
            }).then(response => {
                //extrai dados internos para o array principal
                var dadosRecebidos = extract({
                    jsonLaravel: response.data.data,
                    chaves: [
                        'superior',
                        'grupo',
                        'tipoatributo',
                        'atributo'
                    ]
                });

                //transforma dados no formato aceito pelo reactselect
                if (dadosRecebidos.cliente?.constructor !== Array)
                    dadosRecebidos.cliente = [];
                dadosRecebidos.cliente = dadosRecebidos.cliente.map(function (objeto) {
                    return {
                        value: objeto.id,
                        label: objeto.nome
                    };
                });

                // Define tipoPreco como 'fixo' se não estiver definido
                if (!dadosRecebidos.tipoPreco) {
                    dadosRecebidos.tipoPreco = 'fixo';
                }
                if (!dadosRecebidos.feeBaseTipo) {
                    dadosRecebidos.feeBaseTipo = 'compoe_fee_global';
                }
                if (!dadosRecebidos.feeMomentoCalculo) {
                    dadosRecebidos.feeMomentoCalculo = 'todos';
                }
                if (dadosRecebidos.feeBaseTipo === 'compoe_fee_global') {
                    dadosRecebidos.feeBaseId = null;
                }

                // Formata o preço para exibição
                if (dadosRecebidos.preco) {
                    if (dadosRecebidos.tipoPreco === 'percentual') {
                        // Para percentual, usa pontoVirgula normalmente
                        dadosRecebidos.preco = pontoVirgula(dadosRecebidos.preco);
                    } else {
                        // Para moeda, formata com separadores de milhar
                        const precoDecimal = parseFloat(dadosRecebidos.preco) || 0;
                        if (precoDecimal > 0) {
                            dadosRecebidos.preco = precoDecimal.toLocaleString('pt-BR', {
                                minimumFractionDigits: 2,
                                maximumFractionDigits: 2
                            });
                        } else {
                            dadosRecebidos.preco = '';
                        }
                    }
                }

                setDados(dadosRecebidos);
            }).catch(err => {
                //console.log(err)
            }).finally(() => { setIsLoading(false); });
        } else {
            setIsLoading(false);
        }
    };

    const tratarMudancaPreco = (valorDigitado) => {
        const tipoPrecoAtual = dados.tipoPreco || 'fixo';
        const valorTexto = String(valorDigitado ?? '');

        if (tipoPrecoAtual === 'percentual') {
            // Mantém apenas números e uma vírgula para percentual.
            let valor = valorTexto.replace(/\./g, ',').replace(/[^0-9,]/g, '');
            const partes = valor.split(',');
            if (partes.length > 2) {
                valor = `${partes[0]},${partes.slice(1).join('')}`;
            }
            const [inteiro = '', decimal = ''] = valor.split(',');
            const valorFinal = valor.includes(',') ? `${inteiro},${decimal.slice(0, 4)}` : inteiro;
            setDados({ ...dados, ...{ preco: valorFinal } });
            return;
        }

        // Máscara monetária estável para navegadores: interpreta os dígitos como centavos.
        const apenasDigitos = valorTexto.replace(/\D/g, '');
        if (apenasDigitos === '') {
            setDados({ ...dados, ...{ preco: '' } });
            return;
        }

        const valorLimitado = apenasDigitos.slice(0, 15);
        const centavos = valorLimitado.slice(-2).padStart(2, '0');
        const reais = valorLimitado.slice(0, -2).replace(/^0+(?=\d)/, '');
        const reaisFormatados = (reais || '0').replace(/\B(?=(\d{3})+(?!\d))/g, '.');
        const valorFinal = `${reaisFormatados},${centavos}`;
        setDados({ ...dados, ...{ preco: valorFinal } });
    };

    const salvar = () => {
        
        if (isSubmitting) {
            return;
        }

        setIsSubmitting(true);
if (isSomenteConsulta) {
            toast.error('Seu perfil permite apenas consulta aos itens orçamentários.');
            return;
        }

        // Validação do tipo de preço
        if (!dados.tipoPreco) {
            toast.error('Selecione o tipo de preço (Fixo ou Percentual).');
            return;
        }

        // Converte preco de formato brasileiro para decimal
        const dadosParaSalvar = { ...dados };
        dadosParaSalvar.preco = dados.preco ? virgulaPonto(dados.preco) : null;
        dadosParaSalvar.feeBaseTipo = dados.feeBaseTipo || 'compoe_fee_global';
        dadosParaSalvar.feeMomentoCalculo = dados.feeMomentoCalculo || 'todos';
        if (dadosParaSalvar.feeBaseTipo === 'compoe_fee_global') {
            dadosParaSalvar.feeBaseId = null;
        }
        
        // Limpa o campo quantidade (não mais usado)
        dadosParaSalvar.quantidade = null;

        if (dados.cliente && Array.isArray(dados.cliente)) {
            dadosParaSalvar.cliente = dados.cliente.map(item => item.value).join(',');
        }


        if (id) {//update
            api({
                method: 'put',
                action: '/produto/' + id,
                token: token,
                data: dadosParaSalvar
            })
                .then(function (response) {
                    toast.success("Dados salvos com sucesso!");
                    history.push("/servicoOrcamento");
                })
                .catch(function (error) {
                    toast.error('Erro ao salvar: ' + (error.response?.data?.error ?? error.message ?? ''));
                })
                .finally(() => {
                    setIsSubmitting(false);
                });
        } else {//insert
            api({
                method: 'post',
                action: '/produto',
                token: token,
                data: {
                    ...dadosParaSalvar,
                    ...{ empresa: empresa },
                    ...{ modulo: 'servicoOrcamento' },
                }
            })
                .then(function (response) {
                    toast.success("Dados salvos com sucesso!");
                    history.push("/servicoOrcamento");
                })
                .catch(function (error) {
                    toast.error('Erro ao salvar: ' + (error.response?.data?.error ?? error.message ?? ''));
                })
                .finally(() => {
                    setIsSubmitting(false);
                });
        }
    };

    const abrirModalNovoGrupo = () => {
        setNovoGrupo({ nome: '', codigo: '', ordem: '' });
        setShowModalNovoGrupo(true);
    };

    const salvarNovoGrupo = async () => {
        if (!novoGrupo.nome || !novoGrupo.nome.trim()) {
            toast.error('Informe o nome do grupo orçamentário.');
            return;
        }

        setSalvandoNovoGrupo(true);
        try {
            const response = await api({
                method: 'post',
                action: '/produto',
                token: token,
                data: {
                    nome: novoGrupo.nome.trim(),
                    codigo: novoGrupo.codigo ? novoGrupo.codigo.trim() : null,
                    ordem: novoGrupo.ordem ? Number(novoGrupo.ordem) : null,
                    empresa: empresa,
                    modulo: 'servicoOrcamento',
                    situacaoRegistro: 'ativo',
                    mostrarOrcamento: 'nao',
                    superior: null,
                    tipoPreco: 'fixo',
                    preco: null,
                    quantidade: null,
                }
            });

            const grupoCriado = response?.data?.data ?? {};
            const labelGrupo = grupoCriado?.codigo
                ? `${grupoCriado.codigo} - ${grupoCriado.nome}`
                : (grupoCriado?.nome ?? novoGrupo.nome.trim());

            setDados({
                ...dados,
                superior: grupoCriado?.id ?? null,
                nomeSuperior: labelGrupo,
            });
            setGrupoSelectKey((valorAtual) => valorAtual + 1);
            setShowModalNovoGrupo(false);
            toast.success('Grupo orçamentário criado com sucesso.');
        } catch (error) {
            toast.error(error?.response?.data?.error || 'Erro ao criar grupo orçamentário.');
        } finally {
            setSalvandoNovoGrupo(false);
        }
    };

    useEffect(() => { //onload
        if (isSomenteConsulta) {
            toast.info('Seu perfil permite apenas consulta aos itens orçamentários.');
            history.replace("/servicoOrcamento");
            return;
        }
        const el = document.querySelector("#nome");
        if (el) el.focus(); //autofocus no nome
        buscar();
    },
        // eslint-disable-next-line
        []);

    return (
        <ErpTemplate processando={isLoading}>
            <div className="main-content container-fluid">
                <div className="page-title">
                    <h3>Item Orçamentário</h3>
                </div>
                <section id="multiple-column-form">
                    <div className="row match-height">
                        <div className="col-sm-12">
                            <div className="card">
                                <div className="card-content">
                                    <div className="card-body">
                                        <form className="form" onSubmit={(e) => { salvar(); e.preventDefault(); }}>
                                            <div className="row">
                                                <div className="col-sm-4">
                                                    <div className="form-group">
                                                        <label>Situação</label>
                                                        <ReactSelect
                                                            value={{ value: dados.situacaoRegistro, label: dados.nomeSituacaoRegistro }}
                                                            onChange={e => setDados({ ...dados, ...{ "situacaoRegistro": e.value, "nomeSituacaoRegistro": e.label } })}
                                                            options={[
                                                                { value: 'ativo', label: 'Ativo' },
                                                                { value: 'inativo', label: 'Inativo' },
                                                            ]}
                                                        />
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="row">
                                                <div className="col-sm-6">
                                                    <div className="form-floating form-group">
                                                        <input type="text" className="form-control form-control-lg" id="codigo" placeholder="Código"
                                                            value={dados.codigo}
                                                            onChange={e => setDados({ ...dados, ...{ "codigo": e.target.value } })}
                                                        />
                                                        <label htmlFor="floatingInput">Código</label>
                                                    </div>
                                                </div>
                                                <div className="col-sm-6">
                                                    <div className="form-floating form-group">
                                                        <input type="text" className="form-control form-control-lg" id="codigoFornecedor" placeholder="Código do Fornecedor"
                                                            value={dados.codigoFornecedor}
                                                            onChange={e => setDados({ ...dados, ...{ "codigoFornecedor": e.target.value } })}
                                                        />
                                                        <label htmlFor="floatingInput">Código do Fornecedor</label>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="row">
                                                <div className="col-sm-6">
                                                    <div className="form-group">
                                                        <label>Grupo Orçamentário</label>
                                                        <div className="d-flex align-items-start gap-2">
                                                            <div style={{ flex: 1 }}>
                                                                <ReactSelect
                                                                    key={grupoSelectKey}
                                                                    value={dados.superior ? { value: dados.superior, label: dados.nomeSuperior } : null}
                                                                    onChange={e => setDados({ ...dados, ...{ "superior": e.value, "nomeSuperior": e.label } })}
                                                                    loadOptions={(input) => {
                                                                        return api({
                                                                            method: 'get',
                                                                            action: '/produto',
                                                                            token: token,
                                                                            params: {
                                                                                situacaoRegistro: 'ativo',
                                                                                nome: input,
                                                                                modulo: "servicoOrcamento",
                                                                                superiorIsNull: true,
                                                                            }
                                                                        })
                                                                            .then(response => {
                                                                                let options = response.data.data.map(registro => ({ value: registro.id, label: registro.codigo + " - " + registro.nome }));
                                                                                return options;
                                                                            })
                                                                            .catch(function (error) {
                                                                                //console.log(error);
                                                                            });
                                                                    }}
                                                                />
                                                            </div>
                                                            {!isSomenteConsulta && (
                                                                <button
                                                                    type="button"
                                                                    className="btn btn-outline-primary"
                                                                    title="Adicionar novo grupo orçamentário"
                                                                    onClick={abrirModalNovoGrupo}
                                                                    style={{ height: '38px', minWidth: '42px' }}
                                                                >
                                                                    <FaPlus size={14} />
                                                                </button>
                                                            )}
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="col-sm-6">
                                                    <div className="form-floating form-group">
                                                        <input type="text" className="form-control form-control-lg" id="ordem" placeholder="Ordem"
                                                            value={dados.ordem}
                                                            onChange={e => setDados({ ...dados, ...{ "ordem": e.target.value } })}
                                                        />
                                                        <label htmlFor="floatingInput">Ordem</label>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="row">
                                                <div className="col-sm-4">
                                                    <div className="form-group">
                                                        <label>Grupo Atributo</label>
                                                        <ReactSelect
                                                            value={{ value: dados.grupo, label: dados.nomeGrupo }}
                                                            onChange={e => setDados({ ...dados, ...{ "grupo": e.value, "nomeGrupo": e.label } })}
                                                            loadOptions={(input) => {
                                                                return api({
                                                                    method: 'get',
                                                                    action: '/produtoGrupo',
                                                                    token: token,
                                                                    params: {
                                                                        nome: input,
                                                                    }
                                                                })
                                                                    .then(response => {
                                                                        let options = response.data.data.map(registro => ({ value: registro.id, label: registro.codigo + " - " + registro.nome }));
                                                                        return options;
                                                                    })
                                                                    .catch(function (error) {
                                                                        //console.log(error);
                                                                    });
                                                            }}
                                                        />
                                                    </div>
                                                </div>
                                                <div className="col-sm-4">
                                                    <div className="form-group">
                                                        <label>Tipo Atributo</label>
                                                        <ReactSelect
                                                            value={{ value: dados.tipoatributo, label: dados.nomeTipoatributo }}
                                                            onChange={e => setDados({ ...dados, ...{ "tipoatributo": e.value, "nomeTipoatributo": e.label } })}
                                                            loadOptions={(input) => {
                                                                return api({
                                                                    method: 'get',
                                                                    action: '/produtoTipoAtributo',
                                                                    token: token,
                                                                    params: {
                                                                        nome: input,
                                                                    }
                                                                })
                                                                    .then(response => {
                                                                        let options = response.data.data.map(registro => ({ value: registro.id, label: registro.codigo + " - " + registro.nome }));
                                                                        return options;
                                                                    })
                                                                    .catch(function (error) {
                                                                        //console.log(error);
                                                                    });
                                                            }}
                                                        />
                                                    </div>
                                                </div>
                                                <div className="col-sm-4">
                                                    <div className="form-group">
                                                        <label>Atributo</label>
                                                        <ReactSelect
                                                            value={{ value: dados.atributo, label: dados.nomeAtributo }}
                                                            onChange={e => setDados({ ...dados, ...{ "atributo": e.value, "nomeAtributo": e.label } })}
                                                            loadOptions={(input) => {
                                                                return api({
                                                                    method: 'get',
                                                                    action: '/produtoAtributo',
                                                                    token: token,
                                                                    params: {
                                                                        nome: input,
                                                                    }
                                                                })
                                                                    .then(response => {
                                                                        let options = response.data.data.map(registro => ({ value: registro.id, label: registro.codigo + " - " + registro.nome }));
                                                                        return options;
                                                                    })
                                                                    .catch(function (error) {
                                                                        //console.log(error);
                                                                    });
                                                            }}
                                                        />
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="row">
                                                <div className="col-sm-12">
                                                    <div className="form-floating form-group">
                                                        <input type="text" className="form-control form-control-lg" id="nome" placeholder="Nome"
                                                            value={dados.nome}
                                                            onChange={e => setDados({ ...dados, ...{ "nome": e.target.value } })}
                                                        />
                                                        <label htmlFor="floatingInput">Nome</label>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="row">
                                                <div className="col-sm-6">
                                                    <div className="form-group">
                                                        <label>Tipo de Preço</label>
                                                        <ReactSelect
                                                            value={{ 
                                                                value: dados.tipoPreco || 'fixo', 
                                                                label: dados.tipoPreco === 'percentual' ? 'Percentual (%)' : 'Fixo (R$)' 
                                                            }}
                                                            onChange={e => setDados({ ...dados, ...{ "tipoPreco": e.value } })}
                                                            options={[
                                                                { value: 'fixo', label: 'Fixo (R$)' },
                                                                { value: 'percentual', label: 'Percentual (%)' },
                                                            ]}
                                                        />
                                                    </div>
                                                </div>
                                                <div className="col-sm-6">
                                                    <div className="form-floating form-group">
                                                        <input type="text" className="form-control form-control-lg right" id="preco" 
                                                            placeholder={dados.tipoPreco === 'percentual' ? 'Percentual' : 'Preço'}
                                                            value={dados.preco || ''}
                                                            autoComplete="off"
                                                            inputMode={dados.tipoPreco === 'percentual' ? 'decimal' : 'numeric'}
                                                            onChange={e => tratarMudancaPreco(e.target.value)}
                                                            onBlur={e => {
                                                                if ((dados.tipoPreco || 'fixo') === 'percentual') {
                                                                    const valor = String(e.target.value || '').replace(',', '.');
                                                                    const valorNumero = Number.parseFloat(valor);
                                                                    if (!Number.isNaN(valorNumero)) {
                                                                        setDados({ ...dados, ...{ "preco": pontoVirgula(valorNumero) } });
                                                                    } else if (!e.target.value) {
                                                                        setDados({ ...dados, ...{ "preco": '' } });
                                                                    }
                                                                }
                                                            }}
                                                        />
                                                        <label htmlFor="floatingInput">
                                                            {dados.tipoPreco === 'percentual' ? 'Percentual (%)' : 'Preço (R$)'}
                                                        </label>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="row">
                                                <div className="col-sm-4">
                                                    <div className="form-group">
                                                        <label>Fixo nos Orçamentos</label>
                                                        <ReactSelect
                                                            id="mostrarOrcamento"
                                                            value={{ value: dados.mostrarOrcamento, label: dados.nomeMostrarOrcamento }}
                                                            onChange={e => setDados({ ...dados, ...{ "mostrarOrcamento": e.value, "nomeMostrarOrcamento": e.label } })}
                                                            options={[
                                                                { value: 'nao', label: 'Não' },
                                                                { value: 'sim', label: 'Sim' }
                                                            ]}
                                                        />
                                                    </div>
                                                </div>
                                                <div className="col-sm-4">
                                                    <div className="form-group">
                                                        <label>Categoria</label>
                                                        <ReactSelect
                                                            id="categoria"
                                                            value={{ value: dados.categoria, label: dados.nomeCategoria }}
                                                            onChange={e => setDados({ ...dados, ...{ "categoria": e.value, "nomeCategoria": e.label } })}
                                                            options={[
                                                                { value: 'criacao', label: 'Criação' },
                                                                { value: 'digital', label: 'Digital' },
                                                                { value: 'presencial', label: 'Presencial' }
                                                            ]}
                                                        />
                                                    </div>
                                                </div>
                                                <div className="col-sm-4">
                                                    <div className="form-group">
                                                        <label>Cliente</label>
                                                        <ReactSelect
                                                            isMulti={true}
                                                            value={dados.cliente}
                                                            onChange={(e) => {
                                                                dados.cliente = dados.cliente || [];
                                                                dados.cliente = e;
                                                                setDados({ ...dados });
                                                            }}
                                                            loadOptions={(input) => {
                                                                return api({
                                                                    method: 'get',
                                                                    action: '/participante',
                                                                    token: token,
                                                                    params: {
                                                                        nome: input,
                                                                        tipoCadastro: "cliente",
                                                                        situacaoRegistro: "ativo"
                                                                    }
                                                                })
                                                                    .then(response => {
                                                                        let options = response.data.data.map((registro) => {
                                                                            var label = registro.codigo +
                                                                                ' - ' + registro.nome +
                                                                                (registro.enderecomunicipio ? ' - ' + registro.enderecomunicipio.nome + '-' + registro.enderecomunicipio.uf : '') +
                                                                                (registro.cnpj ? ' (' + registro.cnpj + ')' : '') +
                                                                                (registro.cpf ? ' (' + registro.cpf + ')' : '') +
                                                                                (registro.nomefantasia ? ' - ' + registro.nomefantasia : '');
                                                                            return {
                                                                                value: registro.id,
                                                                                label: label
                                                                            };
                                                                        });
                                                                        return options;
                                                                    })
                                                                    .catch(function (error) {
                                                                        //console.log(error);
                                                                    });
                                                            }}
                                                        />
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="row">
                                                <div className="col-sm-12">
                                                    <div className="form-group">
                                                        <label>Somar Todos que Compõem o FEE</label>
                                                        <ReactSelect
                                                            value={
                                                                dados.somarTodosFee
                                                                    ? { value: dados.somarTodosFee, label: dados.somarTodosFee === 'sim' ? 'Sim' : 'Não' }
                                                                    : { value: 'nao', label: 'Não' }
                                                            }
                                                            onChange={(e) => {
                                                                setDados({ ...dados, somarTodosFee: e.value });
                                                            }}
                                                            options={[
                                                                { value: 'sim', label: 'Sim' },
                                                                { value: 'nao', label: 'Não' }
                                                            ]}
                                                        />
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="row">
                                                <div className="col-sm-4">
                                                    <div className="form-group">
                                                        <label>Base de Cálculo do FEE</label>
                                                        <ReactSelect
                                                            value={{
                                                                value: dados.feeBaseTipo || 'compoe_fee_global',
                                                                label:
                                                                    dados.feeBaseTipo === 'superior_especifico'
                                                                        ? 'Grupo Orçamentário Específico'
                                                                        : dados.feeBaseTipo === 'atributo_especifico'
                                                                            ? 'Atributo Específico'
                                                                            : 'Global (Compõe FEE)'
                                                            }}
                                                            onChange={(e) => {
                                                                setDados({
                                                                    ...dados,
                                                                    feeBaseTipo: e.value,
                                                                    feeBaseId: null,
                                                                    nomeFeeBaseId: null
                                                                });
                                                            }}
                                                            options={[
                                                                { value: 'compoe_fee_global', label: 'Global (Compõe FEE)' },
                                                                { value: 'superior_especifico', label: 'Grupo Orçamentário Específico' },
                                                                { value: 'atributo_especifico', label: 'Atributo Específico' }
                                                            ]}
                                                        />
                                                    </div>
                                                </div>
                                                <div className="col-sm-4">
                                                    <div className="form-group">
                                                        <label>Alvo da Base do FEE</label>
                                                        {dados.feeBaseTipo === 'superior_especifico' && (
                                                            <ReactSelect
                                                                value={
                                                                    dados.feeBaseId
                                                                        ? { value: dados.feeBaseId, label: dados.nomeFeeBaseId || dados.feeBaseId }
                                                                        : null
                                                                }
                                                                onChange={(e) => {
                                                                    setDados({
                                                                        ...dados,
                                                                        feeBaseId: e?.value ?? null,
                                                                        nomeFeeBaseId: e?.label ?? null
                                                                    });
                                                                }}
                                                                loadOptions={(input) => {
                                                                    return api({
                                                                        method: 'get',
                                                                        action: '/produto',
                                                                        token: token,
                                                                        params: {
                                                                            situacaoRegistro: 'ativo',
                                                                            nome: input,
                                                                            modulo: 'servicoOrcamento',
                                                                            superiorIsNull: true
                                                                        }
                                                                    })
                                                                        .then(response => response.data.data.map(registro => ({
                                                                            value: registro.id,
                                                                            label: (registro.codigo ? `${registro.codigo} - ` : '') + registro.nome
                                                                        })))
                                                                        .catch(() => []);
                                                                }}
                                                            />
                                                        )}
                                                        {dados.feeBaseTipo === 'atributo_especifico' && (
                                                            <ReactSelect
                                                                value={
                                                                    dados.feeBaseId
                                                                        ? { value: dados.feeBaseId, label: dados.nomeFeeBaseId || dados.feeBaseId }
                                                                        : null
                                                                }
                                                                onChange={(e) => {
                                                                    setDados({
                                                                        ...dados,
                                                                        feeBaseId: e?.value ?? null,
                                                                        nomeFeeBaseId: e?.label ?? null
                                                                    });
                                                                }}
                                                                loadOptions={(input) => {
                                                                    return api({
                                                                        method: 'get',
                                                                        action: '/produtoAtributo',
                                                                        token: token,
                                                                        params: { nome: input }
                                                                    })
                                                                        .then(response => response.data.data.map(registro => ({
                                                                            value: registro.id,
                                                                            label: (registro.codigo ? `${registro.codigo} - ` : '') + registro.nome
                                                                        })))
                                                                        .catch(() => []);
                                                                }}
                                                            />
                                                        )}
                                                        {(!dados.feeBaseTipo || dados.feeBaseTipo === 'compoe_fee_global') && (
                                                            <input
                                                                type="text"
                                                                className="form-control form-control-lg"
                                                                value="Global (itens marcados com Compõe FEE = Sim)"
                                                                disabled
                                                            />
                                                        )}
                                                    </div>
                                                </div>
                                                <div className="col-sm-4">
                                                    <div className="form-group">
                                                        <label>Momento do Cálculo do FEE</label>
                                                        <ReactSelect
                                                            value={{
                                                                value: dados.feeMomentoCalculo || 'todos',
                                                                label:
                                                                    dados.feeMomentoCalculo === 'pre_evento'
                                                                        ? 'Somente Pré-Evento'
                                                                        : dados.feeMomentoCalculo === 'negociado'
                                                                            ? 'Somente Negociado'
                                                                            : dados.feeMomentoCalculo === 'fechamento'
                                                                                ? 'Somente Fechamento'
                                                                                : 'Todos'
                                                            }}
                                                            onChange={(e) => {
                                                                setDados({ ...dados, feeMomentoCalculo: e.value });
                                                            }}
                                                            options={[
                                                                { value: 'todos', label: 'Todos' },
                                                                { value: 'pre_evento', label: 'Somente Pré-Evento' },
                                                                { value: 'negociado', label: 'Somente Negociado' },
                                                                { value: 'fechamento', label: 'Somente Fechamento' }
                                                            ]}
                                                        />
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="row">
                                                <div className="col-sm-12">
                                                    <div className="form-floating form-group">
                                                        <input type="text" className="form-control form-control-lg" id="descritivo1" placeholder="descritivo1"
                                                            value={dados.descritivo1}
                                                            onChange={e => setDados({ ...dados, ...{ "descritivo1": e.target.value } })}
                                                        />
                                                        <label htmlFor="floatingInput">descritivo1</label>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="row">
                                                <div className="col-sm-12">
                                                    <div className="form-floating form-group">
                                                        <input type="text" className="form-control form-control-lg" id="descritivo2" placeholder="descritivo2"
                                                            value={dados.descritivo2}
                                                            onChange={e => setDados({ ...dados, ...{ "descritivo2": e.target.value } })}
                                                        />
                                                        <label htmlFor="floatingInput">descritivo2</label>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="row">
                                                <div className="col-sm-12">
                                                    <div className="form-floating form-group">
                                                        <input type="text" className="form-control form-control-lg" id="descritivo3" placeholder="descritivo3"
                                                            value={dados.descritivo3}
                                                            onChange={e => setDados({ ...dados, ...{ "descritivo3": e.target.value } })}
                                                        />
                                                        <label htmlFor="floatingInput">descritivo3</label>
                                                    </div>
                                                </div>
                                            </div>

                                            <div className="row">
                                                <div className="col-sm-12 d-flex justify-content-between">
                                                    <button 
                                                        type="button" 
                                                        className="btn btn-secondary me-1 mb-1"
                                                        onClick={() => history.push('/servicoOrcamento')}
                                                    >
                                                        <FaArrowLeft size={20} /> Voltar
                                                    </button>
                                                    {!isSomenteConsulta && (
                                                        <SaveButton isSubmitting={isSubmitting} />
                                                    )}
                                                </div>
                                            </div>
                                        </form>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
            </div>

            <Modal show={showModalNovoGrupo} onHide={() => setShowModalNovoGrupo(false)} centered>
                <Modal.Header closeButton>
                    <Modal.Title>Novo Grupo Orçamentário</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <div className="form-group mb-3">
                        <label>Nome do Grupo</label>
                        <input
                            type="text"
                            className="form-control"
                            value={novoGrupo.nome}
                            onChange={(e) => setNovoGrupo({ ...novoGrupo, nome: e.target.value })}
                            placeholder="Ex.: Alimentação"
                        />
                    </div>
                    <div className="row">
                        <div className="col-sm-6">
                            <div className="form-group mb-3">
                                <label>Código (opcional)</label>
                                <input
                                    type="text"
                                    className="form-control"
                                    value={novoGrupo.codigo}
                                    onChange={(e) => setNovoGrupo({ ...novoGrupo, codigo: e.target.value })}
                                    placeholder="Automático se vazio"
                                />
                            </div>
                        </div>
                        <div className="col-sm-6">
                            <div className="form-group mb-3">
                                <label>Ordem (opcional)</label>
                                <input
                                    type="number"
                                    min="0"
                                    className="form-control"
                                    value={novoGrupo.ordem}
                                    onChange={(e) => setNovoGrupo({ ...novoGrupo, ordem: e.target.value })}
                                />
                            </div>
                        </div>
                    </div>
                </Modal.Body>
                <Modal.Footer>
                    <button
                        type="button"
                        className="btn btn-secondary"
                        onClick={() => setShowModalNovoGrupo(false)}
                        disabled={salvandoNovoGrupo}
                    >
                        Cancelar
                    </button>
                    <button
                        type="button"
                        className="btn btn-primary"
                        onClick={salvarNovoGrupo}
                        disabled={salvandoNovoGrupo}
                    >
                        {salvandoNovoGrupo ? 'Salvando...' : 'Salvar Grupo'}
                    </button>
                </Modal.Footer>
            </Modal>
        </ErpTemplate>
    );
}
